import request from '@/utils/request'

//检查用户是否已维护个人信息
export function checkUserIsPerfect() {
	return request({
		url: '/v1/business/checkUserIsPerfect',
		method: 'get'
	})
}
//我的考试
export function myExam(data, type) {
	return request({
		url: '/v1/business/answer/list/' + type,
		method: 'get',
		params: data
	})
}

//我的证书
export function certList(data) {
	return request({
		url: '/v1/business/cert/list',
		method: 'post',
		params: data
	})
}
//我的订单
export function orderList(data) {
	return request({
		url: '/v1/pay/orderList',
		method: 'get',
		params: data
	})
}
//试卷回显
export function answerPaperEcho(type) {
	return request({
		url: '/v1/business/answerPaperEcho/' + type,
		method: 'get'
	})
}
//工作单位列表
export function companyList(userName) {
	return request({
		url: '/business/company/list?userName=' + userName,
		method: 'get'
	})
}
//工作单位列表分页
export function listByPage(data) {
	return request({
		url: '/business/company/listByPage',
		method: 'get',
		params: data
	})
}
//新增工作单位
export function addCompany(data) {
	return request({
		url: '/business/company/add',
		method: 'post',
		data: data
	})
}
//我的工作经历
export function myWorkExperiences() {
	return request({
		url: '/business/workExperience/myWorkExperiences',
		method: 'get'
	})
}
//新增工作经历
export function addExperience(data) {
	return request({
		url: '/business/workExperience/add',
		method: 'post',
		data: data
	})
}
//工作经历详情
export function getExperience(type) {
	return request({
		url: '/business/workExperience/' + type,
		method: 'get'
	})
}
//查询单位
export function companyName(type) {
	return request({
		url: '/business/company/list?companyName=' + type,
		method: 'get'
	})
}